let table_Table = require("../templates/table/Table.handlebars");
let survey_welcome = require("../templates/pos/comp/Survey_Welcome.handlebars");
let $ = require('jquery');
let _ = require("underscore");
let Backbone = require("backbone");
let OverviewModel = require("../model/OverviewModel.js");
let PagingView = require("./comp/PagingView.js");
let GuideView = require("./comp/GuideView.js");
let PagingModel = require("../model/PagingModel.js");
import POS from "../POS.js";

let i18n = require("../utils/i18n");
let DbRecorder = require("../recorder/DbRecorder.js");
let {LogUtil} = require('../utils/utils');

let main = function () {
    return Backbone.View.extend({
        tablePageView: null,

        events: {
            'click .aTable': 'toTableView',
            'click .filter': 'filterTable',
            'click .clear-table': "clearTable",
            'click .aTable-clean': "clearAtable",
            'click .generateDemoData': "generateDemoData"
        },

        initialize: function () {
            if (!this.model) {
                this.model = new OverviewModel();
            }
            var surveyList = [];
            var self = this;
            this._throttled_render = _.debounce(_.bind(this.render, this), 1000);
            /** this.listenTo(POS.get("tableCollection"), "change", function (target) {
                self._throttled_render();
            }); */
            $(window).on("resize", this._throttled_render);
            POS.get("tableCollection").forEach(function (table) {
                table.on("change", function () {
                    self._throttled_render();
                });
            });
            setInterval(function () {
                console.log("flush table");
                self.render();
            }, 60000);
        },
        render: function () {
            var self = this, webOrderEnabled = POS.getRestaurant().get('webOrderEnabled');
            var showGuide = false //POS.checkBillAmount() == 0;
            var requiresConfirmationAlert = false;
            self.$(".tableList").empty();
            self.$('.tableFilter .colourCode .filter .unpaid').text(POS.get("tableUnpaidSum"));
            self.$('.tableFilter .colourCode .filter .paid').text(POS.get("tablePaidSum"));
            self.$('.tableFilter .colourCode .filter .closed').text(POS.get("tableClosedSum"));
            POS.get("tableCollection").each(function (it) {
                //没有开启网络点单的餐厅不显示网络餐桌
                if (!webOrderEnabled && it.get('multiple')) {
                    return;
                }

                var totalOriginalAmount = 0, totalShouldPayAmount = 0;
                it.refreshStatus();
                it.getActiveBillCollection().each(function (bill) {
                    bill.calculateAmount();
                    bill.calculateRefund();
                    totalShouldPayAmount += bill.getShouldPayAmount();
                    totalOriginalAmount += bill.getOriginalShouldPayAmount();
                });
                var json = it.toJSON();
                json["_code"] = "pos.status." + it.get("status").toLowerCase();
                json["_orderAmount"] = (totalShouldPayAmount > 0 ? totalShouldPayAmount : totalOriginalAmount);

                if (it.get('multiple')) {
                    json.takeaway = true;
                    json.outstandingOrders = 0;
                    it.getActiveBillCollection().each(function (bill) {
                        if (bill.getRefundStatus() != "Total") {
                            json.outstandingOrders++;
                        }
                    });
                }
                var allConfirmed = true;
                it.getActiveBillCollection().each(function (bill) {
                    if (!bill.isConfirmed()) {
                        allConfirmed = false;
                    }
                });
                json.blink = false;
                if (!allConfirmed) {
                    json.blink = true;
                    requiresConfirmationAlert = true;
                }
                self.$(".tableList").append(table_Table(json));
            });

            if (requiresConfirmationAlert) {
                try {
                    if ($('#audioAlert').get(0).paused) {
                        if (window.AndroidClient) {
                            window.AndroidClient.playAudio(true);
                        }
                        console.log("play alert");
                        $('#audioAlert').get(0).loop = true;
                        $('#audioAlert').get(0).play();
                    }
                } catch (e) {
                    console.warn("Your browser doesn't support play ogg");
                }
            } else {
                try {
                    if (window.AndroidClient) {
                        window.AndroidClient.playAudio(false);
                    }
                    $('#audioAlert').get(0).currentTime = 0;
                    $('#audioAlert').get(0).pause();
                } catch (e) {
                    console.warn("Your browser doesn't support play ogg");
                }
            }
            let screenWidth = $(window).width();
            let rowHeight = 180;
            if (screenWidth > 768) {
                rowHeight = 180;
            } else if (screenWidth > 500) {
                rowHeight = 150;
            } else {
                rowHeight = 105;
            }
            var viewHeight = $(window).height() - 60 - this.$('.tableFilter').height();
            var rowSize = Math.floor($(window).width() / rowHeight);
            this.tablePageView = new PagingView({
                el: this.$('.tableList'), pagingControl: this.$('.paging'),
                model: new PagingModel({
                    viewHeight: viewHeight,
                    rowSize: rowSize, rowHeight: rowHeight, itemSize: this.$('.pitem').size()
                })
            });
            this._filterTablesAndRender(undefined);
            if (window.location.hash.indexOf("overview") > 0 && showGuide && self.options.guideView.options.restStatus != "old") {
                if (POS.getRestaurant().get("experienceRestaurant")) {
                    self.options.guideView.model.clear({silent: true});
                    self.options.guideView.model.set({
                        welcome: $(survey_welcome())
                    });
                    self.options.guideView.$el.find('.guideImage').addClass('img-cursor-pointer');
                } else {
                    self.options.guideView.model.clear({silent: true});
                    self.options.guideView.model.set({
                        guideImage: "<img src= " + i18n.msg('pos.survey.step1.image') + ">"
                    });
                    self.options.guideView.$el.find('.guideImage').addClass('img-cursor-pointer');
                }
            }

            var clearTableStatus = false;
            POS.get("tableCollection").each(function (item) {
                if (item.get("status") == "Paid") {
                    clearTableStatus = true;
                }
            });
            if (clearTableStatus) {
                self.$('.tableFilter .clear-table').removeClass('inactive');
                self.$('.tableFilter .clear-table').addClass('active');
            } else {
                self.$('.tableFilter .clear-table').removeClass('active');
                self.$('.tableFilter .clear-table').addClass('inactive');
            }
            return this;
        },

        pageUp: function () {
            this.tablePageView.pageUp();
        },

        pageDown: function () {
            this.tablePageView.pageDown();
        },

        toTableView: function (evt) {
            var tableId = $(evt.currentTarget).data('id');
            analytics('send', 'event', 'Overview', 'openTable', POS.getRestaurant().get('name'));
            LogUtil.info('OverviewView', 'open table ' + tableId);

            $(evt.currentTarget).removeClass('animated');
            var table = POS.getTable(tableId);
            try {
                if (window.AndroidClient) {
                    window.AndroidClient.playAudio(false);
                }
                $('#audioAlert').get(0).pause();
                $('#audioAlert').get(0).currentTime = 0;
                if (table.get("multiple")) {
                    var latestBillId;
                    table.getBillCollection().each(function (item) {
                        if (item) {
                            if (!latestBillId || latestBillId < item.id) {
                                latestBillId = item.id;
                            }
                        }
                    });
                    if (latestBillId) {
                        DbRecorder.saveNow("lastNotifiedTakeawayBill", latestBillId);
                    }
                }
            } catch (e) {
                console.warn("Your browser doesn't support play ogg");
            }

            Backbone.history.navigate("table/" + tableId, {trigger: true});
        },

        clearAtable:function(evt){
            var table  = POS.get('tableCollection').findWhere({id:$(evt.currentTarget).closest('.aTable').data('id')});
            if (table.get("status") == "Closed" || !table.canClose()) {
                return false;
            }
            if (table.get("status") == "Paid" && !table.isWebTable()) {
                table.close();
            }
            Backbone.history.navigate('overview', {trigger: true});
            return false;
        },

        clearTable: function () {
            var self = this;
            POS.get("tableCollection").each(function (item) {
                if (item.get("status") == "Closed" || !item.canClose()) {
                    return false;
                }
                if (item.get("status") == "Paid" && !item.isWebTable()) {
                    item.close();
                }
            });
            Backbone.history.navigate('overview', {trigger: true});
        },
        filterTable: function (evt) {
            var oldStatus = this.model.get('filter'), filter = $(evt.currentTarget).closest(".filter");

            if (filter.hasClass('selected')) {
                filter.removeClass('selected');
                this.$('.filter.all').addClass('selected');
            } else {
                this.$('.selected').removeClass('selected');
                filter.addClass('selected');
            }

            if (filter.find('.paid').length > 0) {
                this.model.set({filter: 'Paid'});

            } else if (filter.find('.unpaid').length > 0) {
                this.model.set({filter: 'Unpaid'});

            } else if (filter.find('.no_order').length > 0) {
                this.model.set({filter: 'no_order'});

            } else if (filter.find('.closed').length > 0) {
                this.model.set({filter: 'Closed'});
            }
            this._filterTablesAndRender(oldStatus);
        },
        _filterTablesAndRender: function (oldStatus) {
            var currentStatus = this.model.get('filter');

            if (currentStatus == undefined || oldStatus == currentStatus) {
                //this.$('.aTable.filtered').removeClass('filtered');
                this.model.set({filter: undefined});
                this.$('.pitem-hidden').removeClass('pitem-hidden').addClass('pitem');

            } else {
                this.$('.aTable').each(function (i, item) {
                    if ($(item).attr("status") != currentStatus) {
                        $(item).addClass('pitem-hidden').removeClass('pitem');

                    } else {
                        $(item).removeClass('pitem-hidden').addClass('pitem');
                    }
                });
            }

            // analytics('send', 'event', 'Overview', 'filterTable', POS.getRestaurant().get('name'));
            LogUtil.info('OverviewView', 'filterTable' + currentStatus);

            this.tablePageView.render();
        },
        generateDemoData: function () {
            $("#bigLoading").removeClass("hidden");
            var result = $.post('/pos/generateDemoData');
            result.done(function (res) {
                if (res.status == 200) {
                } else {
                    alert(i18n.msg("pos.generate.demo.data.fail"));
                }
                window.location.reload();
            });
        }
    })
        ;
};

let exportedValue = main();

export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/OverviewView.js